if (!customElements.get('content-cards-body')) {
  class ContentCardsBody extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updateHeight();

      window.addEventListener('resize', ()=> this.updateHeight());
    }

    updateHeight() {
      this.closest('section')?.style.setProperty('--body-height', `${this.offsetHeight}px`)
    }
  }
  customElements.define('content-cards-body', ContentCardsBody);
}
